module.exports = __webpack_public_path__ + "img/2012-08-18 12.47.57.d91dbc89.jpg";